import React from 'react'

const DEFAULT_KEY = 'default'

const renderStyle = (id, media = {}) => {
  const mapped = Object.keys(media).map(k => {
    if (DEFAULT_KEY === k) {
      return `
                .jumbo-header.jumbo-header-${id} {
                    background-image: url(${media[k]});
                }
            `
    } else {
      return `
                @media only screen and (max-width: ${k}) {
                    .jumbo-header.jumbo-header-${id} {
                        background-image: url(${media[k]});
                    }
                }
            `
    }
  })

  return mapped.join('\n')
}

export default function JumboHeader({
  title,
  media = {},
  styleId = 'default',
}) {
  const css = media ? renderStyle(styleId, media) : ''
  if (typeof title === 'string') {
    let className = ''
    if (!media) {
      className = 'text-center text-xxl'
    }
    title = <h1 className={className}>{title}</h1>
  }
  title = typeof title === 'string' ? <h1>{title}</h1> : title

  return (
    <div>
      <style>{css}</style>
      <div className={media ? `jumbo-header jumbo-header-${styleId}` : ''}>
        {title}
      </div>
    </div>
  )
}
